import Input from './Input';

export { default as InputTheme } from './Input.style';
export default Input;
